module.exports = __webpack_public_path__ + "static/media/LearnCreatorSchoolwide.7a636ce1.jpg";